import {
  BASE_EXCHANGE_URL,
  BASE_EXCHANGE_INFO_URL,
  SUSHI_BASE_URL,
  SUSHI_ANALYTICS_URL,
  NIPPLE_BASE_URL,
  NIPPLE_ANALYTICS_URL,
  // JET_BASE_URL,
  // JET_ANALYTICS_URL,
  SPIRIT_BASE_URL,
  SPIRIT_ANALYTICS_URL,
  YOSHI_BASE_URL,
} from 'config'
import tokens from './tokens'
import lpTokens from './lpTokens'
import { FarmConfig } from './types'

const farms: FarmConfig[] = [
  /**
   * These 3 farms (PID 0, 251, 252) should always be at the top of the file.
   */
  {
    pid: 0,
    ...lpTokens.dmd_usdc_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
    isTokenOnly: true,
  },
  {
    pid: 1,
    ...lpTokens.dmd_wftm_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
  },
  {
    pid: 2,
    ...lpTokens.dmd_fusdt_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
  },
  {
    pid: 3,
    ...lpTokens.dmd_dai_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
  },
  {
    pid: 4,
    ...lpTokens.dmd_usdc_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
  },
  {
    pid: 21,
    ...lpTokens.dmd_mim_lp,
    symbol: 'MIM-DMD LP',
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
  },
  {
    pid: 27,
    ...lpTokens.dmd_weth_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
  },
  {
    pid: 28,
    ...lpTokens.dmd_wbtc_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
  },
  {
    pid: 31,
    ...lpTokens.dmd_dola_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
  },
  {
    pid: 5,
    ...lpTokens.usdc_ftm_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
    fee: 2,
  },
  {
    pid: 6,
    ...lpTokens.ftm_weth_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
    fee: 2,
  },
  {
    pid: 7,
    ...lpTokens.ftm_bnb_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
    fee: 2,
  },
  {
    pid: 8,
    ...lpTokens.usdc_dai_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
    fee: 2,
  },
  {
    pid: 9,
    ...lpTokens.usdc_fusdt_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
    fee: 2,
  },
  {
    pid: 10,
    ...lpTokens.ftm_wbtc_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
    fee: 2,
  },
  {
    pid: 11,
    symbol: 'FTM-Sushi LP',
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
    address: {
      4002: '',
      250: '0xf84E313B36E86315af7a06ff26C8b20e9EB443C3',
    },
    token: tokens.sushi,
    quoteToken: tokens.wftm,
    fee: 2,
  },
  {
    pid: 12,
    symbol: 'CRV-FTM LP',
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
    address: {
      4002: '',
      250: '0xB471Ac6eF617e952b84C6a9fF5de65A9da96C93B',
    },
    token: tokens.crv,
    quoteToken: tokens.wftm,
    fee: 2,
  },
  {
    pid: 13,
    symbol: 'YFI-ETH LP',
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
    address: {
      4002: '',
      250: '0x0845c0bFe75691B1e21b24351aAc581a7FB6b7Df',
    },
    token: tokens.yfi,
    quoteToken: tokens.eth,
    fee: 2,
  },
  {
    pid: 14,
    ...lpTokens.usdc_ftm_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
    isTokenOnly: true,
    fee: 2,
  },
  {
    pid: 15,
    ...lpTokens.dmd_usdc_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
    isTokenOnly: true,
    fee: 2,
  },
  {
    pid: 16,
    ...lpTokens.dmd_dai_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
    isTokenOnly: true,
    fee: 2,
  },
  {
    pid: 17,
    ...lpTokens.usdc_fusdt_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
    isTokenOnly: true,
    fee: 2,
  },
  {
    pid: 18,
    ...lpTokens.ftm_wbtc_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
    isTokenOnly: true,
    fee: 2,
  },
  {
    pid: 19,
    ...lpTokens.ftm_weth_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
    isTokenOnly: true,
    fee: 2,
  },
  {
    pid: 20,
    ...lpTokens.ftm_bnb_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
    isTokenOnly: true,
    fee: 2,
  },
  {
    pid: 22,
    ...lpTokens.ftm_mim_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
    fee: 2,
  },
  {
    pid: 23,
    ...lpTokens.ftm_mim_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
    isTokenOnly: true,
    fee: 2,
  },
  {
    pid: 24,
    ...lpTokens.ftm_boo_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
    isTokenOnly: true,
    fee: 2,
  },
  {
    pid: 25,
    ...lpTokens.dai_ftm_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
    fee: 2,
  },
  {
    pid: 26,
    ...lpTokens.cgs_wftm_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
  },
  {
    pid: 29,
    ...lpTokens.wbtc_weth_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
    fee: 2,
  },
  {
    pid: 32,
    ...lpTokens.egunk_wftm_lp,
    addLiquidityBaseUrl: SUSHI_BASE_URL,
    infoBaseUrl: `${SUSHI_ANALYTICS_URL}/pairs`,
  },
  {
    pid: 39,
    ...lpTokens.egunk_wftm_spirit_lp,
    addLiquidityBaseUrl: SPIRIT_BASE_URL,
    infoBaseUrl: `${SPIRIT_ANALYTICS_URL}/pair`,
  },
  {
    pid: 33,
    ...lpTokens.pgunk_wftm_lp,
    addLiquidityBaseUrl: SUSHI_BASE_URL,
    infoBaseUrl: `${SUSHI_ANALYTICS_URL}/pairs`,
  },
  {
    pid: 38,
    ...lpTokens.pgunk_ftm_spirit_lp,
    addLiquidityBaseUrl: SPIRIT_BASE_URL,
    infoBaseUrl: `${SPIRIT_ANALYTICS_URL}/pair`,
  },
  {
    pid: 34,
    ...lpTokens.nips_wftm_lp,
    addLiquidityBaseUrl: NIPPLE_BASE_URL,
    infoBaseUrl: `${NIPPLE_ANALYTICS_URL}/pairs`,
    fee: 1,
  },
  {
    pid: 35,
    ...lpTokens.mim_slurp_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
  },
  {
    pid: 36,
    ...lpTokens.reaper_wftm_lp,
    addLiquidityBaseUrl: SPIRIT_BASE_URL,
    infoBaseUrl: `${SPIRIT_ANALYTICS_URL}/pair`,
  },
  {
    pid: 40,
    ...lpTokens.yoshi_usdc_lp,
    siteUrl: YOSHI_BASE_URL,
  },
  {
    pid: 41,
    ...lpTokens.yoshi_wftm_lp,
    siteUrl: YOSHI_BASE_URL,
  },
  {
    pid: 42,
    ...lpTokens.devil_mim_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
  },
  {
    pid: 43,
    ...lpTokens.r4id_usdc_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
  },
  {
    pid: 45,
    ...lpTokens.gem_ham_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
  },
  {
    pid: 46,
    ...lpTokens.gem_wftm_lp,
    addLiquidityBaseUrl: BASE_EXCHANGE_URL,
    infoBaseUrl: `${BASE_EXCHANGE_INFO_URL}/pair`,
  },

  // {
  //  pid: 30,
  //  symbol: 'FTM-MAX LP',
  //  address: {
  //   4002: '',
  //    250: '0xa15A9Af64ac736D15A8A610947166b6ae6A11026',
  //  },
  //  token: tokens.max,
  //  quoteToken: tokens.wftm,
  // },
]

export default farms
